// extracted by mini-css-extract-plugin
export default {"LikeIcon":"Likes_LikeIcon__oi8c4","Like":"Likes_Like__2OOik","Icon":"Likes_Icon__rTUV6","LikesInfo":"Likes_LikesInfo__P2sLp"};